import { motion } from "framer-motion";

const phrases = [
  "SYNTHESIZING WORLD EVENTS",
  "SCANNING LOCAL HEADLINES",
  "DRAFTING YOUR CAPSULE",
  "VOICING THE NEWSROOM",
  "POLISHING THE TRANSCRIPT",
];

function statusLabel(status) {
  if (status === "generating_script") return "WRITING SCRIPT";
  if (status === "generating_audio") return "RECORDING AUDIO";
  return "PREPARING";
}

export default function LoadingMarquee({ status, progressPct = 0, cutoffSeconds }) {
  const items = [...phrases, ...phrases];
  const pct = Math.max(0, Math.min(100, Math.round(progressPct || 0)));

  return (
    <div
      data-testid="loading-marquee"
      className="fixed inset-0 z-50 flex flex-col items-center justify-center bg-zinc-50 grain"
    >
      <div className="w-full overflow-hidden border-y border-zinc-950 py-8">
        <motion.div
          className="flex gap-12 whitespace-nowrap"
          initial={{ x: 0 }}
          animate={{ x: "-50%" }}
          transition={{ repeat: Infinity, duration: 22, ease: "linear" }}
        >
          {items.map((p, i) => (
            <span
              key={`${p}-${i}`}
              className="font-display text-6xl md:text-8xl font-black tracking-tight text-zinc-950"
            >
              {p} <span className="text-rose-600">/</span>
            </span>
          ))}
        </motion.div>
      </div>

      <div className="mt-10 flex w-full max-w-2xl flex-col items-center gap-4 px-6">
        {/* Progress bar */}
        <div className="w-full">
          <div className="flex items-baseline justify-between">
            <span data-testid="loading-status" className="font-mono text-[11px] uppercase tracking-[0.3em] text-zinc-600">
              {statusLabel(status)}
            </span>
            <span data-testid="loading-progress" className="font-display text-4xl font-black tracking-tight text-zinc-950 tabular-nums">
              {pct}<span className="text-rose-600">%</span>
            </span>
          </div>
          <div className="mt-3 h-1.5 w-full bg-zinc-200 overflow-hidden">
            <motion.div
              className="h-full bg-rose-600"
              initial={{ width: 0 }}
              animate={{ width: `${pct}%` }}
              transition={{ duration: 0.6, ease: "easeOut" }}
              data-testid="loading-progress-bar"
            />
          </div>
        </div>

        <p className="mt-2 text-center text-sm text-zinc-500">
          Curating today's stories{status === "generating_audio" ? " and recording your audio" : ""}. 
          {cutoffSeconds ? ` Hard cutoff at ${Math.round(cutoffSeconds / 60)} min.` : ""}
        </p>
      </div>
    </div>
  );
}
